// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__sAaB3","body":"style_body__LEZHI"};